import type { Note } from '@/types';
import { NotesCircles } from './NotesCircles';

interface NotesGridProps {
  myNote: Note | null;
  entries: Note[];
}

export function NotesGrid({ myNote, entries }: NotesGridProps) {
  return <NotesCircles layout="grid" myNote={myNote} entries={entries} />;
}
